import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MainApp } from "../MainApp";
import "../Sentry";
import store from "../store/store";
import "../../tailwind.css";

const queryClient = new QueryClient();
const root = createRoot(document.getElementById("app-container"));
import "../i18n";
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <MainApp />
    </Provider>
  </QueryClientProvider>
);
